import qs from "qs";
import newSupportService from "@/services/newSupportService";
import supportService from "@/services/supportService";
import { objToQuery } from "@/utils/index";

/**
 * 获取订单列表
 * @param {*} page
 * @param {*} size
 * @param {*} language
 */
export function getOrders(page = 1, size = 10, language) {
  // return newSupportService.post(
  //   "/account",
  //   qs.stringify({
  //     action: "get-orders",
  //     language,
  //     page: page,
  //     per_page: size
  //   })
  // );
  return newSupportService.get(
    // 使用绝对地址 单独 查询订单
    `https://gw.aoscdn.com/base/payment/users/transactions?page=${page}&per_page=${size}&language=${language}`
  );
}

/**
 * 获取发票列表
 * @param {*} page
 * @param {*} size
 * @param {*} language
 */
export function getInvoices(page = 1, size = 10, language) {
  return supportService.post(
    "/account",
    qs.stringify({
      action: "get-invoice-list",
      language,
      page: page,
      per_page: size,
    })
  );
}

/**
 * 获取工单列表
 * @param {*} page
 * @param {*} size
 * @param {*} language
 */
export function getTickets(page = 1, size = 10, language) {
  return newSupportService.post(
    "/account",
    qs.stringify({
      action: "get-tickets",
      language,
      page: page,
      per_page: size,
    })
  );
}

/**
 * 查询订单状态
 * @param {*} transactionId
 */
export function queryOrderStatus(transactionId) {
  return newSupportService.get(
    // "/buy/apowersoft?action=query_order_status&nocache=1",
    `/transactions/${transactionId}`
    // qs.stringify({
    //   transaction_id: transactionId
    // }),
    // {
    //   timeout: 50000
    // }
  );
}

/**
 * 生成订单
 * @param {*} couponCode
 * @param {*} products
 * @param {*} identityToken
 * @param {*} referer
 */
export function generateOrder(couponCode, products, identityToken, referer) {
  // const postData = new FormData();
  // if (couponCode) {
  //   postData.append("coupon_code", couponCode);
  // }
  // postData.append("type", "attachment");
  // postData.append("identity_token", identityToken);
  // postData.append("Referer", referer);
  // for (let i = 0, l = products.length; i < l; i++) {
  //   postData.append(`product[${i}][product_id]`, products[i].product_id);
  //   postData.append(`product[${i}][quantity]`, products[i].quantity);
  // }
  const postData = {
    product: products,
    provider_type: 1,
    language: "en",
    referer: referer,
  };
  return newSupportService.post(
    //     genOrders: 'POST /buy/apowersoft?action=generate_order&nocache=1',
    // 'https://gw.aoscdn.com/base/payment'
    // genOrders: 'POST /transactions',
    // "/buy/apowersoft?action=generate_order&nocache=1",
    "/transactions",
    postData
  );
}

export function submitTicket() {}

export function setLiked(review_id) {
  return newSupportService.post(
    "/review",
    qs.stringify({
      action: "approval",
      review_id,
      type: 1,
      nocache: 1,
    })
  );
}

// 提交评论
export function submitReview(queryObject) {
  return newSupportService.get(`/review${objToQuery(queryObject)}`);
}

export function getReviewList(related_id, start, size, language) {
  return newSupportService.post(
    "/review?type=1",
    qs.stringify({
      action: "get_review",
      related_id,
      type: 1,
      start,
      page_num: size,
      language,
    })
  );
}

/**
 * 查询优惠券
 * @param {*} couponCode
 * @param {*} products
 */
export function queryCoupon(couponCode, products) {
  const postData = {
    product: products,
    coupon: couponCode,
  };
  return newSupportService.post("/transactions/coupon", postData);
}
